import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-markdown";
import "common/components/CodeEditor/echo";
function MarkdownEditor({ markdown, setMarkdown }) {
  const onChange = value => {
    setMarkdown(value);
  };

  return (
    <div>
      <AceEditor
        mode="markdown"
        // theme="echo"
        wrapEnabled={true}
        onChange={onChange}
        name="markdown-editor"
        fontSize={16}
        value={markdown}
        editorProps={{ $blockScrolling: true }}
        setOptions={{
          enableBasicAutocompletion: false,
          enableLiveAutocompletion: false,
          enableSnippets: false,
          showLineNumbers: false,
          tabSize: 2
        }}
        style={{ height: "600px", width: "100%" }}
      />
    </div>
  );
}

export default MarkdownEditor;
